import React from "react";
import cx from "classnames";
import { Pill } from "@picklebet/ui";
import { ReactComponent as BonusCashIcon } from "@/features/betslip/assets/bonus-cash.svg";

import * as styles from "@/features/betslip/components/parts/tokens/PromoPills.module.scss";

type BonusCashPillProps = {
  active: boolean;
  onToggle: () => void;
  disabled?: boolean;
};

export const BonusCashPill = ({
  active,
  onToggle,
  disabled,
}: BonusCashPillProps) => (
  <Pill
    className={cx(styles.tokenPill, styles.bonusCash)}
    disabled={disabled}
    pressed={active}
    overrideSvgFill={false}
    onClick={onToggle}
    onMouseDown={(e) => e.preventDefault()}
    data-testid="bonus-cash-pill"
  >
    <span className={styles.icon}>
      <BonusCashIcon />
    </span>
    Bonus Cash
  </Pill>
);
